import React from 'react';
import {Input, message, Modal} from 'antd';
import moment from 'moment';
import type {FileItem} from '../../types/directory';
import {uploadService} from '../../services/upload';
import {copyText, formatShareText, getExpireTimeFromUrl} from '../../utils/share';

export function useFileShare() {
  async function shareFile(record: FileItem) {
    try {
      const url = await uploadService.getTempDownloadUrl({
        obskey: record.obskey
      });

      const expireDate = getExpireTimeFromUrl(url);
      const expireText = expireDate
        ? moment(expireDate).format('YYYY-MM-DD HH:mm:ss')
        : '系统默认';

      const shareText = formatShareText({
        fileName: record.name,
        url,
        expireText
      });

      Modal.confirm({
        title: '分享文件',
        width: 620,
        icon: null,
        content: (
          <div>
            <div style={{marginBottom: 12}}>
              文件名: {record.name}
            </div>

            <Input.TextArea value={url} rows={4} readOnly/>

            <div
              style={{
                marginTop: 8,
                color: '#999',
                fontSize: 12,
              }}
            >
              链接有效期: {expireText}
            </div>
          </div>
        ),
        okText: '复制分享信息',
        cancelText: '复制链接',
        onOk: async () => {
          await copyText(shareText);
          message.success('分享信息已复制');
        },
        async onCancel() {
          await copyText(url);
          message.success('链接已复制');
        }
      });
    } catch (e) {
      message.error('获取分享链接失败');
    }
  }

  return {
    shareFile
  };
}